import React from 'react';
import { notification, Modal } from 'antd';

const logout = () => {
  Promise.all([
    localStorage.removeItem(process.env.REACT_APP_LOCALSTORAGE_USER),
    localStorage.removeItem(process.env.REACT_APP_LOCALSTORAGE_TOKEN),
  ]).then(() => {
    window.location.reload();
  });
};

export default (err) => {
  if (err.response) {
    const { response } = err;
    const { statusCode, body } = response;
    if (statusCode === 422) {
      notification.error({
        message: 'Sorry..',
        description: (
          <ul>
            {body.errors.map((err2) => (
              <li key={err2}>
                {err2.param}
                {' '}
                -
                {' '}
                {err2.msg}
              </li>
            ))}
          </ul>
        ),
        placement: 'bottomRight',
      });
    } else if (statusCode === 401) {
      const { pathname } = window.location;
      if (pathname !== '/') {
        Modal.error({
          centered: true,
          title: 'Unauthorised!',
          content: 'This account is unauthorised, You need to logout!',
          okText: 'Procced',
          onOk() {
            logout();
          },
        });
      } else {
        notification.error({
          message: 'Error...',
          description: 'Something went wrong, Make sure the provided cradentials are correct!',
          placement: 'bottomRight',
        });
      }
    } else if (statusCode === 400) {
      notification.error({
        message: 'Sorry..',
        description: body.msg,
        placement: 'bottomRight',
      });
    } else if (statusCode === 403) {
      notification.warning({
        message: 'Sorry..',
        description: body.msg,
        placement: 'bottomRight',
      });
    }
  } else {
    notification.error({
      message: 'Sorry..',
      description: 'Server Error',
      placement: 'bottomRight',
    });
  }
};
